// extracted by mini-css-extract-plugin
export default {"previewPage":"preview_previewPage__jH4ex","center":"preview_center__kMQe5","newPreviewPage":"preview_newPreviewPage__lbIxR","leftBackBox":"preview_leftBackBox__Ya4Ku"};